module.exports = __webpack_public_path__ + "img/getstarted_hero_mobile.803d8c55.jpg";